// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2Vm6f","author":"Table_author__201v0","authorImage":"Table_authorImage__ShRrV","unreadRow":"Table_unreadRow__2gzOw"};